import React, {useState} from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {BASE_URL} from "../home/BASE_URL";
import {message} from "antd";
import {useDispatch} from "react-redux";
import {setAdminUserDetails} from "../store/reducer";

const Container = styled.div`
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fafafa;
`;

const Form = styled.form`
    background: white;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
`;

const Title = styled.h2`
    margin-bottom: 25px;
    text-align: center;
    color: #722ed1;
`;

const Input = styled.input`
    width: 100%;
    padding: 12px;
    margin-bottom: 20px;
    border-radius: 6px;
    border: 1px solid #ddd;
    font-size: 16px;

    &: focus {
        border: 2px solid blue;
    }
`;

const Button = styled.button`
    width: 100%;
    padding: 12px;
    background: ${({disabled}) => (disabled ? "#bda5e6" : "#722ed1")};
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    cursor: ${({disabled}) => (disabled ? "not-allowed" : "pointer")};
    transition: 0.2s ease;

    &:hover {
        background: ${({disabled}) => (disabled ? "#bda5e6" : "#5b1fb8")};
    }
`;

const PasswordWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const TogglePassword = styled.span`
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-120%);
    cursor: pointer;
    font-size: 14px;
    color: #722ed1;
    user-select: none;
`;

const AdminLogin = () => {
    const [form, setForm] = useState({email: "", password: ""});
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [passwordOpen, setPasswordOpen] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await fetch(`${BASE_URL}/admin/login`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(form),
            });

            const data = await res.json();
            if (res.ok) {
                message.success("Logged in successfully!");

                dispatch(
                    setAdminUserDetails({
                        email: data.admin.email,
                        token: data.token,
                    })
                );

                navigate("/admin/dashboard");
            } else {
                message.error(data.message || "Login failed");
            }

            setLoading(false);
        } catch (err) {
            console.error(err);
            message.error("Server error");
        }
    };

    return (
        <Container>
            <Form onSubmit={handleLogin}>
                <Title>Admin Login</Title>
                <Input
                    type="email"
                    placeholder="Email"
                    value={form.email}
                    onChange={(e) => setForm({...form, email: e.target.value})}
                    required
                />
                <PasswordWrapper>
                    <Input
                        type={passwordOpen ? "text" : "password"}
                        placeholder="Password"
                        value={form.password}
                        onChange={(e) => setForm({...form, password: e.target.value})}
                        required
                    />

                    <TogglePassword onClick={() => setPasswordOpen(!passwordOpen)}>
                        {passwordOpen ? "Hide" : "Show"}
                    </TogglePassword>
                </PasswordWrapper>

                <Button type="submit" disabled={loading}>
                    {loading ? "Loading..." : "Login"}
                </Button>
            </Form>
        </Container>
    );
};

export default AdminLogin;
